module.exports = __webpack_public_path__ + "media/images/expert__calvin-stettler-ceb30be54d56ffec43b26c5cbd1eab0b.png";